module.exports = __webpack_public_path__ + "static/media/entertain-kung-fu.8305ebfd.vtt";